// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLineCardExpandedStyles } from "@bg/Overrides/Widgets/Cart/CartLineCardExpanded";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

cartLineCardExpandedStyles.quantityGridItem = {
    css: css`
        width: calc(100% / 3 + 5px);
        ${xScreen("lte", 900)} {
            width: 100%;
            max-width: 192px;
            & > .editable-qty {
                max-width: 120px;
            }
        }
        ${xScreen("lte", "xs")} {
            order: 2;
            width: auto;
        }
        @media print {
            order: 2;
            display: block;
            width: 30% !important;
            text-align: center;
            legend,
            p,
            span {
                text-align: center;
                width: 150px;
            }
        }
    `,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineCardExpandedStyles.productPrice,
    price: {
        priceText: {
            size: fontConfig.fontSize.regular,
            lineHeight: "17px",
            weight: fontConfig.weight.regular,
            css: css`
                ${xScreen("lte", "md")} {
                    font-size: ${fontConfig.fontSize.large}px;
                    line-height: ${fontConfig.lineHeight.small};
                }
            `,
        },
        unitOfMeasureText: {
            size: fontConfig.fontSize.regular,
            lineHeight: "17px",
            weight: fontConfig.weight.regular,
            css: css`
                text-transform: uppercase;
                ${xScreen("lte", "md")} {
                    font-size: ${fontConfig.fontSize.large}px;
                    line-height: ${fontConfig.lineHeight.small};
                }
            `,
        },
    },
};

cartLineCardExpandedStyles.extendedUnitNetPriceText = {
    size: fontConfig.fontSize.regular,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    css: css`
        word-break: break-word;
        padding-left: 10px;
        text-align: right;
        ${xScreen("lte", 900)} {
            text-align: left;
        }

        ${xScreen("lte", 900)} {
            font-size: ${fontConfig.fontSize.large}px;
            line-height: ${fontConfig.lineHeight.small};
            padding-left: 0;
        }
    `,
};

cartLineCardExpandedStyles.quantity = {
    readOnlyQuantityText: {
        text: {
            size: fontConfig.fontSize.regular,
            lineHeight: "17px",
            weight: fontConfig.weight.bold,
            css: css`
                text-align: center;
                ${xScreen("lte", "md")} {
                    font-size: ${fontConfig.fontSize.large}px;
                    line-height: ${fontConfig.lineHeight.small};
                    padding-left: 4px;
                }
            `,
        },
        heading: {
            as: "legend",
            size: fontConfig.fontSize.legend,
            lineHeight: fontConfig.lineHeight.legend,
            css: css`
                display: none;
                @media (max-width: 900px) {
                    display: block;
                    margin-bottom: 4px;
                }
            `,
        },
    },
};
